import React from 'react';
import { Link } from 'react-router-dom';
import StaticPageLayout from '../components/Layout/StaticPageLayout';

const faqs = [
  {
    q: 'How long does delivery take?',
    a: 'Express delivery typically arrives the next day, and normal delivery within a few days, depending on your location. Exact estimates are shown on each product page. See our Shipping Info page for details.'
  },
  {
    q: 'What payment methods do you accept?',
    a: 'You can pay using the options shown at checkout (cards, UPI, and other supported methods).'
  },
  {
    q: 'Can I return or exchange an item?',
    a: 'Yes - see our Returns page for the return window and conditions.'
  },
  {
    q: 'How do I track my order?',
    a: 'Once logged in, you can view your order status and tracking details from the Orders section of your account.'
  },
  {
    q: 'How do I contact support?',
    a: 'Visit our Contact Us page for our email, phone, and Instagram.'
  }
];

const FAQ = () => {
  return (
    <StaticPageLayout title="Frequently Asked Questions">
      {faqs.map((item) => (
        <div key={item.q}>
          <h2 className="text-lg font-semibold text-gray-900 mb-1">{item.q}</h2>
          <p>{item.a}</p>
        </div>
      ))}
      <p className="text-sm text-gray-500">
        Still have questions? <Link to="/contact" className="text-blue-600 hover:underline">Contact us</Link>.
      </p>
    </StaticPageLayout>
  );
};

export default FAQ;
